import { Component, ViewChild, AfterViewInit, Input, Output, EventEmitter } from '@angular/core';
import { Asset, Equipment } from '../../context-discovery-services/models';

@Component({
  selector: 'adminapp-add-points-to-asset',
  templateUrl: './add-points-to-asset.component.html',
  styleUrls: ['./add-points-to-asset.component.scss']
})
export class AddPointsToAssetComponent implements AfterViewInit {
  @ViewChild('addPointToAssetDialog') addPointToAssetDialog: any;
  @ViewChild('addPointsAssetsList') addPointsAssetsList: any;
  @ViewChild('addPointsAssetsListParent') addPointsAssetsListParent: any;

  @Input()
  assetsList: Array<Asset>;

  @Input()
  equipmentList: Array<Equipment>;

  @Output()
  assetSelected: EventEmitter<string> = new EventEmitter<string>();

  selectedEquipment: string;
  filteredAssetsList: Array<Asset>;

  constructor() { }

  ngAfterViewInit() {
  }

  open(equipmentInContext: string) {
    this.selectedEquipment = equipmentInContext;
    this.addPointToAssetDialog.nativeElement.open();
  }

  onSelectedEquipmentChanged(iri: string) {
    this.addPointsAssetsListParent.nativeElement._markOption(null, false);
    this.addPointsAssetsList.nativeElement.items = this.assetsList.
      filter(asset => asset.equipment && asset.equipment.iri === iri);
  }

  onAssetSelected() {
    this.assetSelected.emit(this.addPointsAssetsListParent.nativeElement.value);
  }
}
